(() => {
  if (customElements.get('teylens-design-start')) return;
  customElements.define('teylens-design-start', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.quiz = this.querySelector('[data-quiz]');
      this.step = 0;
      this.querySelectorAll('[data-start-link]').forEach(link => {
        const destination = new URL(link.getAttribute('href'), window.location.href);
        destination.searchParams.set('start', link.dataset.startLink);
        link.href = destination.href;
      });
      if (!this.quiz) return;
      this.setAttribute('data-enhanced', '');
      this.querySelectorAll('[data-quiz-next],[data-quiz-back],[data-quiz-result],[data-quiz-close],[data-quiz-restart],[data-quiz-progress]').forEach(node => { node.hidden = false; });
      this.setStep(0, false);
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-quiz-next')) {
          if (!this.getChoice('style')) { this.querySelector('[data-style-choice]')?.focus(); return; }
          this.setStep(1);
        } else if (button.hasAttribute('data-quiz-back')) {
          this.setStep(0);
        } else if (button.hasAttribute('data-quiz-result')) {
          if (!this.getChoice('shape')) { this.querySelector('[data-shape-choice]')?.focus(); return; }
          this.updateResult();
          this.setStep(2);
        } else if (button.hasAttribute('data-quiz-restart')) {
          this.setStep(0);
        } else if (button.hasAttribute('data-quiz-close')) {
          this.closeQuiz();
        }
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.quiz.open) {
          event.preventDefault();
          this.closeQuiz();
        }
      }, { signal });
      this.addEventListener('shopify:block:select', event => {
        const block = event.target.closest('.ty-design-start__choice');
        if (!block || !this.contains(block)) return;
        this.quiz.open = true;
        this.setStep(block.querySelector('[data-style-choice]') ? 0 : 1, false);
      }, { signal });
    }
    disconnectedCallback() {
      this.abort?.abort();
    }
    getChoice(type) {
      return this.querySelector(`[data-${type}-choice]:checked`);
    }
    setStep(step, focus = true) {
      this.step = step;
      this.querySelectorAll('[data-quiz-step]').forEach(panel => { panel.hidden = Number(panel.dataset.quizStep) !== step; });
      const progress = this.querySelector('[data-quiz-progress]');
      if (progress) progress.hidden = step === 2;
      const number = this.querySelector('[data-step-number]');
      if (number) number.textContent = String(step + 1);
      if (!focus) return;
      const panel = this.querySelector(`[data-quiz-step="${step}"]`);
      const target = step === 2 ? panel.querySelector('[data-result-heading]') : panel.querySelector('input:checked') || panel.querySelector('input');
      target?.focus({ preventScroll: true });
      panel.scrollIntoView({ block: 'nearest', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    updateResult() {
      const style = this.getChoice('style');
      const shape = this.getChoice('shape');
      const summary = this.querySelector('[data-quiz-selection]');
      if (summary) summary.textContent = `${style.dataset.choiceLabel} · ${shape.dataset.choiceLabel}`;
      const link = this.querySelector('[data-quiz-destination]');
      if (!link || !this.dataset.customUrl) return;
      const destination = new URL(this.dataset.customUrl, window.location.href);
      destination.searchParams.set('start', 'quiz');
      destination.searchParams.set('setting_style', style.value);
      destination.searchParams.set('diamond_shape', shape.value);
      link.href = destination.href;
    }
    closeQuiz() {
      this.quiz.open = false;
      this.quiz.querySelector('summary')?.focus({ preventScroll: true });
    }
  });
})();
